<template>
    <div>
        <div class="py-4">
            <div class="dropdown">
                <div class="card card-body" role="alert">
                    <p class="lead text-center"><strong>Welcome Back, {{this.userData.name}}</strong></p>
                    <!-- p v-if="this.isAdmin"><em>Administrator</em></p -->
                    <div v-if="this.message" class="alert mt-2 alert-warning alert-dismissible fade show" role="alert"><p class="lead">{{this.message}}</p><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>
                </div>
            </div>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row justify-content-md-center">
                <div class="col-xl-8">
                    <div class="card bg-light mb-4 h-100">
                        <div class="card-header"><h4><i class="fas fa-project-diagram"></i> Projects  <div class="badge bg-light text-dark border border-primary" style="color: #000;">BETA</div></h4></div>
                            <div class="card-body">
                                <div class="d-grid gap-2">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col">
                                                <div class="form-group">
                                                    <label>Select a Project</label>
                                                    <select class="form-select" v-model="selectedproject" @change="selectProject">
                                                        <option value="" disabled selected>Make a selection</option>
                                                        <option v-for="(item, index) in projects" :value="item.name" :key="index">{{item.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <a class="btn btn-lg btn-block btn-outline-primary mt-4" @click="$emit('customChange', {shell: 'Projects', dataset: ''})">Manage Projects <i class="fas fa-angle-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row mt-xl-4">
                <div class="col-xl-4">
                    <div class="card bg-light mb-4 h-100">
                        <div class="card-header"><h4><i class="fas fa-database"></i> My Datasets</h4></div>
                            <div class="card-body">
                                <div class="d-grid gap-2">
                                    <a v-if="this.userSubscription.subscription != 'single' || parseInt(this.userSubscription.remaining_dataset) >= 1" class="btn btn-lg btn-block btn-outline-primary" @click="$emit('openModal', {view: 'DatsetUploadDialog', dt: ''})">Upload a Dataset <i class="fas fa-angle-right"></i></a>
                                        <div v-else>
                                            <p class="text-center"><strong>You are out of available Dataset Uploads!</strong></p>
                                            <p class="text-center">To purchase more uploads, or to subscribe for unlimited uploads, please click here:</p>
                                            <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChange', {shell: 'SelectSubscription', dataset: ''})">Manage Subscription &amp; Services <i class="fas fa-angle-right"></i></a>
                                        </div>
                                    <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChange', {shell: 'Datasets', dataset: ''})">Manage Datasets <i class="fas fa-angle-right"></i></a>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="card bg-light mb-4 h-100">
                                    <div class="card-header"><h4><i class="fas fa-chart-line"></i> My Reports</h4></div>
                                    <div class="card-body">
                                        <div class="d-grid gap-2">
                                            <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChange', {shell: 'Reports', dataset: ''})">Manage Reports <i class="fas fa-angle-right"></i></a>
                                            <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('openModal', {view: 'GenerateZipDataset', dt: ''})">Generate ZIPCODE Report <i class="fas fa-angle-right"></i></a>
                                            <!-- <a class="btn btn-lg btn-block btn-outline-primary" href="#"> See My Reports</a> <i class="fas fa-angle-right"></i> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div class="card bg-light mb-4 h-100">
                                    <div class="card-header"><h4><i class="fas fa-users"></i> My Prospects</h4></div>
                                    <div class="card-body">
                                        <div class="d-grid gap-2">
                                            <a class="btn btn-lg btn-block btn-outline-primary" href="#" @click="$emit('customChange', {shell: 'Prospects', dataset: ''})">Get More Prospects <i class="fas fa-angle-right"></i></a>
                                            <!-- <a class="btn btn-lg btn-block btn-outline-primary" href="#">See My Prospect Files <i class="fas fa-angle-right"></i></a> -->
                        </div>
                    </div>                
                </div>
            </div>
        </div>
        <!-- new rows -->
        <div class="row justify-content-md-center mt-xl-4">
            <div class="col-xl-4">
                <div class="card bg-light mb-4 h-100">
                    <div class="card-header"><h4><i class="fas fa-mail-bulk"></i> Email Appends</h4></div>
                    <div class="card-body">
                        <div class="d-grid gap-2">
                            <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChange', {shell: 'EmailAppendBulk', dataset: ''})">Manage Email Appends <i class="fas fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card bg-light mb-4 h-100">
                    <div class="card-header"><h4><i class="fas fa-comment"></i> AI Assistant</h4></div>
                        <div class="card-body">
                            <div class="d-grid gap-2">
                                <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChange', {shell: 'AIAssistant', dataset: ''})">Launch AI Assistant <i class="fas fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="col-xl-4" v-if="this.isAdmin">
                <div class="card bg-light mb-4 h-100">
                    <div class="card-header"><h4><i class="fas fa-map-marker-alt"></i> Geospatial Explorer <div class="badge bg-light text-dark border border-primary" style="color: #000;">BETA</div></h4></div>
                    <div class="card-body">
                        <div class="d-grid gap-2">
                            <a class="btn btn-lg btn-block btn-outline-primary" @click="$emit('customChangeGeospatial', {shell: 'MapTester', dataset: ''})">Launch Map <i class="fas fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- div class="row" v-if="this.isAdmin">
            <div class="col">
                <button class="btn btn-lg btn-primary m-4" @click="$emit('customChange', {shell: 'MapTester', dataset: ''})">Map Tester</button>
            </div>
        </div -->
        <!-- end new rows -->
        <div class="row d-none">
            <div class="col text-center" style="padding-top: 400px">
                <p class="lead">Need help?</p>
                <div class="d-grid gap-2 col-6 mx-auto">
                <a class="btn btn-lg btn-default" @click="$emit('customChange', {shell: 'SupportForm', dataset: ''})"><i class="fas fa-question-circle"></i> Submit a Support Ticket</a>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Dashboard',
    data() {
        return {
            message: '',
            projects: [],
            selectedproject: ''
        }
    },
    props: {
        userData: [],
        userSubscription: [],
        userStatus: '',
        thisRemaining: '',
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    }, 
    methods: {
        get_message() {
            axios.get('/get_motd')
            .then(
                (response) => {
                this.message = response.data; 
                // console.log('MOTD response '+response.data);
                }
            )
            .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        getProjectsList() {
            axios.post('/projects_list')
                .then(
                (response) => {  
                    this.projects = response.data;
                    // console.log('returned list '+JSON.stringify(response.data));
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 

        },
        selectProject() {
            console.log('Project Selected '+this.selectedproject);
            this.$emit('customChangeProject', {shell: 'ProjectDetails', dataset: this.selectedproject, project: this.selectedproject});
        }
    },
    mounted() {

        //console.log('dashboard mounted');
        //connsole.log('Subscription: '+this.userSubscription.subscription);
        //connsole.log('Number remaining: '+this.userSubscription.remaining_dataset);
        if(this.userSubscription.subscription == 'single' || parseInt(this.userSubscription.remaining_dataset) < 1) {
            this.$emit('killPromocode');
        }
        this.get_message();
        this.getProjectsList();
        this.$emit('toggleNavShow');
    }
}
</script>